import React, { ReactNode } from 'react';
import styles from './style.module.scss';

export interface ButtonProps {
  variant: 'primary' | 'secondary' | 'link' | 'misc';
  type?: 'submit' | 'button' | 'reset';
  children: ReactNode | string;
  disabled?: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  classNames?: string;
  dataTestId?: string;
  key?: number | string;
}

export const Button = (props: ButtonProps) => {
  const {
    children,
    variant,
    disabled = false,
    onClick,
    classNames,
    dataTestId = '',
    key = `${dataTestId}__${classNames}`,
    type = 'button',
  } = props;
  const klassNames = `${styles.button} rounded-full font-bold ${classNames} ${styles[variant]}`;
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={klassNames}
      data-testid={dataTestId}
      key={key}
    >
      {children}
    </button>
  );
};
